import React from "react";

function InkAndTonerDropdown() {
  return <div></div>;
}

export default InkAndTonerDropdown;
